import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';
import { map, take } from 'rxjs';

export const subMenuGuard: CanActivateFn = (route, state) => {
  const authSrv = inject(AuthService);
  const router = inject(Router);

  const subMenuId: number | undefined = route.data?.['subMenuId'];

  if (!subMenuId) {
    router.navigate(['page-not-found']);
    return false;
  }

  return authSrv.currentUserLogin$.pipe(
    take(1),
    map((user) => {

      const isAllowed = !!user?.visibleSubMenuIds?.includes(subMenuId);

      if (!isAllowed) {
        router.navigate(['page-not-found']);
      }

      return isAllowed;
    })
  );
};
